import getApi from '@/lib/axios';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function get_acumulo_inadimplencia_por_mes(params={}): Promise<ConsolidationSummaryType> {
  const api = await getApi();

  const { data } = await api.get<ConsolidationSummaryType>('/financeiro/get_acumulo_inadimplencia/', { params });
  return data;
}

export { get_acumulo_inadimplencia_por_mes };
